import { render, staticRenderFns } from "./UpdateCourseCoordinator.vue?vue&type=template&id=44476bda"
import script from "./UpdateCourseCoordinator.vue?vue&type=script&lang=js"
export * from "./UpdateCourseCoordinator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports